module.exports = __webpack_public_path__ + "media/video_07.43c79995.mp4";